import { useMemo } from "react";

import { usePathname } from "next/navigation";

import { useConfig } from "@jti/app-context/useConfig";

import { getLanguageAlternates } from "@/app/_internal/getLanguageAlternates";
import { useLanguageAlternates } from "@/context/LanguageAlternatesProvider";
import { useLocale } from "@/context/LocaleContext";
import { i18n } from "@/libs/i18n";

export const useLanguages = () => {
  const { languages } = useConfig();
  const { currentLocale = i18n.defaultLocale, locales } = useLocale();
  const pathname = usePathname();
  const serverProvidedAlternates = useLanguageAlternates();

  return useMemo(() => {
    if (languages) {
      const pathnameWithoutLocale = pathname.replace(new RegExp(`^/${currentLocale}`), "") || "/";

      const alternates =
        Object.keys(serverProvidedAlternates).length > 0
          ? serverProvidedAlternates
          : getLanguageAlternates({
              pageType: "static",
              locale: currentLocale,
              urlPath: pathnameWithoutLocale,
            });

      const filteredLanguagesList = languages
        .filter(({ locale }) => locale && locales.includes(locale))
        .map((language) => ({
          ...language,
          current: language.locale === currentLocale,
          path:
            language.locale && alternates[language.locale]
              ? `/${language.locale}${alternates[language.locale]}`
              : language.path,
        }));

      return filteredLanguagesList.length > 1 ? filteredLanguagesList : [];
    }
    return [];
  }, [currentLocale, languages, locales, pathname, serverProvidedAlternates]);
};
